import React from "react";
import DataTable from "../common/slds/dataTable";

export default function Playground() {
    return <div>
        <DataTable/>
    </div>
};